export default "__VITE_ASSET__vtgGGZyH__"